import {BrowserRouter, Route, Switch} from "react-router-dom";
import ToastCollection from "./public/toast/ToastCollection";
import React from "react";
import LoginPage from "./pages/LoginPage/LoginPage";
import NoMatchPage from "./pages/NoMatchPage/NoMatchPage";
import InstitutionManagementPage from "./pages/CSM/InstitutionManagementPage";
import SSOLoginComponent from "./components/SSOLoginComponent";
import CSMRedirectComponent from "./pages/CSM/CSMRedirectComponent";
import CSMLayout from "./pages/CSM/CSMLayout";
import InstitutionPage from "./pages/CSM/InstitutionPage";
import AdminPatternPage from "./pages/CSM/AdminPatternPage";
import CSMManagementPage from "./pages/CSM/CSMManagementPage";
import EventBannerManagementPage from "./pages/CSM/EventBannerManagementPage";


export default function CSMApp() {

    return (
        <>
            <ToastCollection />
            <Switch>
                <Route exact path="/" render={() => (<LoginPage />)}/>
                <Route exact path="/home/sso" render={() => (<SSOLoginComponent />)}/>
                <Route exact path="/csm/redirect" render={() => (<CSMRedirectComponent />)}/>
                <Route
                    exact
                    path="/institutions"
                    render={() => (
                        <CSMLayout>
                            <InstitutionManagementPage/>
                        </CSMLayout>
                    )}
                />

                <Route
                    exact
                    path="/users"
                    render={() => (
                        <CSMLayout isAdminExclusive={true}>
                            <CSMManagementPage/>
                        </CSMLayout>
                    )}
                />

                <Route
                    exact
                    path="/institution/:instId?"
                    render={() => (
                        <CSMLayout>
                            <InstitutionPage/>
                        </CSMLayout>
                    )}
                />

                <Route
                    exact
                    path="/admin/patterns"
                    render={() => (
                        <CSMLayout isAdminExclusive={true}>
                            <AdminPatternPage/>
                        </CSMLayout>
                    )}
                />

                <Route
                    exact
                    path="/events"
                    render={() => (
                        <CSMLayout>
                            <EventBannerManagementPage/>
                        </CSMLayout>
                    )}
                />
                <Route component={NoMatchPage} />
            </Switch>
        </>
    );
}